import $ from 'jquery';
import config from './../../config';
const URL_API = config.urlApi+'controlador/inventario_materiales/searchMaterialesUnidadByUnidad.php';

export default function searchMaterialesUnidadByUnidad({values}){
    return $.ajax({
        url: URL_API,
        type: 'POST',
        data: values
    })
}